import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
      <div>
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-xs font-label font-bold uppercase tracking-wider text-accent-600 mb-2">
            <i className="ri-bookmark-3-line"></i>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">
          {title}
        </h2>
        {subtitle && (
          <p className="mt-2 text-sm md:text-base text-foreground-600">{subtitle}</p>
        )}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer shrink-0"
        >
          {moreLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}